export const TRIAL_PAYWALL_WINDOW_EVENTS = {
  OPEN_TRIAL_UNLOCK_MODAL: 'OPEN_TRIAL_UNLOCK_MODAL',
  TRIAL_PAYWALL_CONTEXT_CHANGED: 'TRIAL_PAYWALL_CONTEXT_CHANGED',
  TRIAL_SESSION_EXHAUSTED: 'TRIAL_SESSION_EXHAUSTED',
} as const;

export const HX_TRIAL_PAYWALL_WINDOW_KEY = '__HX_TRIAL_PAYWALL__';

export type HxTrialPaywallWindowState = {
  isTrial: boolean;
  isLockedOut: boolean;
};
